import React from "react";
import {OpenInNew} from "@mui/icons-material";
import {useStores} from "../../stores";
import type {MatPartReviewRow} from "../../services/classes/MaterializedClasses";
import type {SearchConfiguration, SearchType} from "../../customization/SearchConfiguration";

type Props = {
    type: SearchType
    objs: any[]
    children?: React.ReactNode
}
export const GoogleLink: React.FC<Props> = ({type, objs, children}) => {
    const {p} = useStores();
    if (p.p.searchConfiguration) {
        const {query, fullLink} = buildGoogleQuery(type, p.p.searchConfiguration, objs);
        if (query) {
            const url = `https://www.google.com/search?q=${encodeURIComponent(query)}`;
            if (fullLink) {
                return <a
                    href={url}
                    title="Search on Google"
                    target="_blank"
                    rel="noopener noreferrer">
                    {children}
                </a>
            } else {
                return <div
                    className="link-secondary">
                    <a
                        className="link-secondary-icon"
                        href={url}
                        title="Search on Google"
                        target="_bank"
                        rel="noopener noreferrer">
                        <OpenInNew fontSize="inherit"/>
                        {/*<CallMade fontSize="inherit"/>*/}
                        {/*<Google fontSize="inherit"/>*/}
                    </a>
                    {children}
                </div>
            }
        }
    }
    return <>{children}</>
}

type Q = {query: string | null, fullLink: boolean};

function buildGoogleQuery(type: SearchType, config: SearchConfiguration, objs: any[]): Q {
    switch (config) {
        case 'default_p_desc':
            switch (type) {
                case 'part': {
                    const part = objs[0] as MatPartReviewRow;
                    return {query: part.p_description ?? null, fullLink: false};
                }
                case 'part_with_supplier': {
                    // @deprecated SingularMatPartReviewRowState
                    const partWithSupplier = objs[0] as any & {s_name: string};
                    return {query: partWithSupplier.s_name, fullLink: false};
                }
                case "supplier": {
                    // @deprecated SomeMatSupplierReviewRow
                    const supplier = objs[0] as any & {s_name: string};
                    return {query: supplier.s_name, fullLink: false};
                }
            }
            break
        case 'context1':
            switch (type) {
                case 'part': {
                    const p_part = objs[0] as MatPartReviewRow;
                    return {query: p_part.p_description ?? null, fullLink: false};
                }
                case 'part_with_supplier': {
                    // @deprecated SingularMatPartReviewRowState
                    const partWithSupplier = objs[0] as any & {s_name: string};
                    return {
                        query: partWithSupplier.s_name + ' ' + partWithSupplier.p_context_1,
                        fullLink: false,
                    };
                }
                case "supplier": {
                    // @deprecated SomeMatSupplierReviewRow
                    const supplier = objs[0] as any & {s_name: string};
                    const firstPart = objs.at(1) as MatPartReviewRow;
                    return {
                        query: supplier.s_name + (firstPart ? (' ' + firstPart.p_context_1) : ''),
                        fullLink: false,
                    };
                }
            }
            break
    }
}
